
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  SuperAdmin: 'SuperAdmin',
  PlatoUser: 'PlatoUser',
  PlatoCustomer: 'PlatoCustomer',
  PlatoApiKey: 'PlatoApiKey',
  SalesRepAssignment: 'SalesRepAssignment',
  UserManager: 'UserManager',
  CrmCustomer: 'CrmCustomer',
  CrmCustomerAddress: 'CrmCustomerAddress',
  CrmCustomerContact: 'CrmCustomerContact',
  CrmCustomerStatusChange: 'CrmCustomerStatusChange',
  CrmEvent: 'CrmEvent',
  CrmEventOrder: 'CrmEventOrder',
  CrmLink: 'CrmLink',
  CrmInteractionLink: 'CrmInteractionLink',
  CrmNote: 'CrmNote',
  CrmTask: 'CrmTask',
  CrmComment: 'CrmComment',
  CrmAttachment: 'CrmAttachment',
  InsUsedInsight: 'InsUsedInsight',
  InsInsightOutcome: 'InsInsightOutcome',
  BsrBusinessRule: 'BsrBusinessRule',
  BsrRuleCondition: 'BsrRuleCondition',
  BsrRuleEntityLink: 'BsrRuleEntityLink',
  BsrRuleSource: 'BsrRuleSource',
  AiSuggestionFeedback: 'AiSuggestionFeedback',
  UiFilterView: 'UiFilterView',
  DraftSalesOrder: 'DraftSalesOrder'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const SuperAdminScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  clerkId: 'clerkId',
  lastLoginAt: 'lastLoginAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SuperAdminScalarFieldEnum = (typeof SuperAdminScalarFieldEnum)[keyof typeof SuperAdminScalarFieldEnum]


export const PlatoUserScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  descriptionString: 'descriptionString',
  platoCustomerId: 'platoCustomerId',
  clerkId: 'clerkId',
  erpUserId: 'erpUserId',
  lastLoginAt: 'lastLoginAt',
  inviteToken: 'inviteToken',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  role: 'role'
} as const

export type PlatoUserScalarFieldEnum = (typeof PlatoUserScalarFieldEnum)[keyof typeof PlatoUserScalarFieldEnum]


export const PlatoCustomerScalarFieldEnum = {
  id: 'id',
  name: 'name',
  legalEntityName: 'legalEntityName',
  slug: 'slug',
  domain: 'domain',
  starrocksDatabase: 'starrocksDatabase',
  manticoreEndpoint: 'manticoreEndpoint',
  manticoreDatabase: 'manticoreDatabase',
  webshopUrl: 'webshopUrl',
  configName: 'configName',
  crmDisplayConfig: 'crmDisplayConfig',
  crmCustomFieldsConfig: 'crmCustomFieldsConfig',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlatoCustomerScalarFieldEnum = (typeof PlatoCustomerScalarFieldEnum)[keyof typeof PlatoCustomerScalarFieldEnum]


export const PlatoApiKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  tenantId: 'tenantId',
  verifier: 'verifier'
} as const

export type PlatoApiKeyScalarFieldEnum = (typeof PlatoApiKeyScalarFieldEnum)[keyof typeof PlatoApiKeyScalarFieldEnum]


export const SalesRepAssignmentScalarFieldEnum = {
  salesRepId: 'salesRepId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SalesRepAssignmentScalarFieldEnum = (typeof SalesRepAssignmentScalarFieldEnum)[keyof typeof SalesRepAssignmentScalarFieldEnum]


export const UserManagerScalarFieldEnum = {
  subordinateId: 'subordinateId',
  managerId: 'managerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserManagerScalarFieldEnum = (typeof UserManagerScalarFieldEnum)[keyof typeof UserManagerScalarFieldEnum]


export const CrmCustomerScalarFieldEnum = {
  erpCustomerId: 'erpCustomerId',
  tenantId: 'tenantId',
  annualSalesPotential: 'annualSalesPotential',
  associationMemberships: 'associationMemberships',
  branch: 'branch',
  creditLimitAllowed: 'creditLimitAllowed',
  creditLimitUsed: 'creditLimitUsed',
  customerType: 'customerType',
  dunningLevel: 'dunningLevel',
  emailAddress: 'emailAddress',
  employeeCount: 'employeeCount',
  facebookUrl: 'facebookUrl',
  faxNumber: 'faxNumber',
  linkedInUrl: 'linkedInUrl',
  name: 'name',
  orderBlock: 'orderBlock',
  ownExhibition: 'ownExhibition',
  paymentTerms: 'paymentTerms',
  phoneNumber: 'phoneNumber',
  priceGroup: 'priceGroup',
  region: 'region',
  taxNumber: 'taxNumber',
  websiteUrl: 'websiteUrl',
  businessStatus: 'businessStatus',
  customFields: 'customFields',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CrmCustomerScalarFieldEnum = (typeof CrmCustomerScalarFieldEnum)[keyof typeof CrmCustomerScalarFieldEnum]


export const CrmCustomerAddressScalarFieldEnum = {
  erpCustomerId: 'erpCustomerId',
  tenantId: 'tenantId',
  addressId: 'addressId',
  canReceiveGoodsAtNight: 'canReceiveGoodsAtNight',
  canReceiveParcels: 'canReceiveParcels',
  comment: 'comment',
  isPreferredShippingAddress: 'isPreferredShippingAddress',
  customFields: 'customFields'
} as const

export type CrmCustomerAddressScalarFieldEnum = (typeof CrmCustomerAddressScalarFieldEnum)[keyof typeof CrmCustomerAddressScalarFieldEnum]


export const CrmCustomerContactScalarFieldEnum = {
  erpCustomerId: 'erpCustomerId',
  tenantId: 'tenantId',
  contactId: 'contactId',
  birthday: 'birthday',
  comment: 'comment',
  department: 'department',
  role: 'role',
  customFields: 'customFields'
} as const

export type CrmCustomerContactScalarFieldEnum = (typeof CrmCustomerContactScalarFieldEnum)[keyof typeof CrmCustomerContactScalarFieldEnum]


export const CrmCustomerStatusChangeScalarFieldEnum = {
  id: 'id',
  fromStatus: 'fromStatus',
  toStatus: 'toStatus',
  reason: 'reason',
  reasonRich: 'reasonRich',
  createdAt: 'createdAt',
  tenantId: 'tenantId',
  erpCustomerId: 'erpCustomerId',
  createdById: 'createdById'
} as const

export type CrmCustomerStatusChangeScalarFieldEnum = (typeof CrmCustomerStatusChangeScalarFieldEnum)[keyof typeof CrmCustomerStatusChangeScalarFieldEnum]


export const CrmEventScalarFieldEnum = {
  eventId: 'eventId',
  description: 'description',
  title: 'title',
  agenda: 'agenda',
  agendaRich: 'agendaRich',
  address: 'address',
  startDate: 'startDate',
  startTime: 'startTime',
  endTime: 'endTime',
  linkedEntity: 'linkedEntity',
  attendees: 'attendees',
  recurrence: 'recurrence',
  recurrenceWeeks: 'recurrenceWeeks',
  recurrenceWeekdays: 'recurrenceWeekdays',
  recurrenceUntil: 'recurrenceUntil',
  recurrenceExcludedDates: 'recurrenceExcludedDates',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId',
  createdById: 'createdById'
} as const

export type CrmEventScalarFieldEnum = (typeof CrmEventScalarFieldEnum)[keyof typeof CrmEventScalarFieldEnum]


export const CrmEventOrderScalarFieldEnum = {
  eventId: 'eventId',
  eventDate: 'eventDate',
  eventPosition: 'eventPosition',
  tenantId: 'tenantId'
} as const

export type CrmEventOrderScalarFieldEnum = (typeof CrmEventOrderScalarFieldEnum)[keyof typeof CrmEventOrderScalarFieldEnum]


export const CrmLinkScalarFieldEnum = {
  linkId: 'linkId',
  taskId: 'taskId',
  modelType: 'modelType',
  modelId: 'modelId',
  title: 'title',
  various: 'various',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId',
  createdById: 'createdById'
} as const

export type CrmLinkScalarFieldEnum = (typeof CrmLinkScalarFieldEnum)[keyof typeof CrmLinkScalarFieldEnum]


export const CrmInteractionLinkScalarFieldEnum = {
  linkId: 'linkId',
  sourceType: 'sourceType',
  sourceId: 'sourceId',
  targetType: 'targetType',
  targetId: 'targetId',
  linkKind: 'linkKind',
  targetSnapshot: 'targetSnapshot',
  metadata: 'metadata',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId',
  createdById: 'createdById'
} as const

export type CrmInteractionLinkScalarFieldEnum = (typeof CrmInteractionLinkScalarFieldEnum)[keyof typeof CrmInteractionLinkScalarFieldEnum]


export const CrmNoteScalarFieldEnum = {
  noteId: 'noteId',
  erpNoteId: 'erpNoteId',
  noteType: 'noteType',
  interactionHappened: 'interactionHappened',
  title: 'title',
  titleRich: 'titleRich',
  occurredAt: 'occurredAt',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pinnedAt: 'pinnedAt',
  createdVia: 'createdVia',
  tenantId: 'tenantId',
  customerId: 'customerId',
  createdById: 'createdById',
  eventId: 'eventId'
} as const

export type CrmNoteScalarFieldEnum = (typeof CrmNoteScalarFieldEnum)[keyof typeof CrmNoteScalarFieldEnum]


export const CrmTaskScalarFieldEnum = {
  taskId: 'taskId',
  erpTaskId: 'erpTaskId',
  status: 'status',
  description: 'description',
  descriptionRich: 'descriptionRich',
  dueDate: 'dueDate',
  taskIntent: 'taskIntent',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt',
  createdVia: 'createdVia',
  tenantId: 'tenantId',
  assignedToId: 'assignedToId',
  assignedById: 'assignedById',
  createdById: 'createdById',
  noteId: 'noteId'
} as const

export type CrmTaskScalarFieldEnum = (typeof CrmTaskScalarFieldEnum)[keyof typeof CrmTaskScalarFieldEnum]


export const CrmCommentScalarFieldEnum = {
  commentId: 'commentId',
  content: 'content',
  contentRich: 'contentRich',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  taskId: 'taskId',
  noteId: 'noteId',
  tenantId: 'tenantId',
  createdById: 'createdById'
} as const

export type CrmCommentScalarFieldEnum = (typeof CrmCommentScalarFieldEnum)[keyof typeof CrmCommentScalarFieldEnum]


export const CrmAttachmentScalarFieldEnum = {
  attachmentId: 'attachmentId',
  externalUuid: 'externalUuid',
  cdnUrl: 'cdnUrl',
  cdnUrlModifiers: 'cdnUrlModifiers',
  s3Url: 's3Url',
  s3Bucket: 's3Bucket',
  name: 'name',
  size: 'size',
  mimeType: 'mimeType',
  isImage: 'isImage',
  previewCdnUrl: 'previewCdnUrl',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  taskId: 'taskId',
  noteId: 'noteId',
  tenantId: 'tenantId',
  createdById: 'createdById'
} as const

export type CrmAttachmentScalarFieldEnum = (typeof CrmAttachmentScalarFieldEnum)[keyof typeof CrmAttachmentScalarFieldEnum]


export const InsUsedInsightScalarFieldEnum = {
  insightId: 'insightId',
  reaction: 'reaction',
  usedAt: 'usedAt',
  hiddenAt: 'hiddenAt',
  notes: 'notes',
  reason: 'reason',
  taskId: 'taskId',
  tenantId: 'tenantId'
} as const

export type InsUsedInsightScalarFieldEnum = (typeof InsUsedInsightScalarFieldEnum)[keyof typeof InsUsedInsightScalarFieldEnum]


export const InsInsightOutcomeScalarFieldEnum = {
  id: 'id',
  actionableEntityId: 'actionableEntityId',
  actionableEntityType: 'actionableEntityType',
  insightId: 'insightId',
  insightType: 'insightType',
  insight: 'insight',
  text: 'text',
  textRich: 'textRich',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  response: 'response',
  createdById: 'createdById',
  tenantId: 'tenantId',
  erpCustomerId: 'erpCustomerId',
  noteId: 'noteId'
} as const

export type InsInsightOutcomeScalarFieldEnum = (typeof InsInsightOutcomeScalarFieldEnum)[keyof typeof InsInsightOutcomeScalarFieldEnum]


export const BsrBusinessRuleScalarFieldEnum = {
  id: 'id',
  path: 'path',
  name: 'name',
  description: 'description',
  ruleType: 'ruleType',
  scope: 'scope',
  version: 'version',
  isActive: 'isActive',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  updatedById: 'updatedById',
  tenantId: 'tenantId'
} as const

export type BsrBusinessRuleScalarFieldEnum = (typeof BsrBusinessRuleScalarFieldEnum)[keyof typeof BsrBusinessRuleScalarFieldEnum]


export const BsrRuleConditionScalarFieldEnum = {
  id: 'id',
  conditionType: 'conditionType',
  condition: 'condition',
  appliesToField: 'appliesToField',
  createdAt: 'createdAt',
  tenantId: 'tenantId',
  ruleId: 'ruleId'
} as const

export type BsrRuleConditionScalarFieldEnum = (typeof BsrRuleConditionScalarFieldEnum)[keyof typeof BsrRuleConditionScalarFieldEnum]


export const BsrRuleEntityLinkScalarFieldEnum = {
  id: 'id',
  entityType: 'entityType',
  entityId: 'entityId',
  note: 'note',
  createdAt: 'createdAt',
  tenantId: 'tenantId',
  ruleId: 'ruleId'
} as const

export type BsrRuleEntityLinkScalarFieldEnum = (typeof BsrRuleEntityLinkScalarFieldEnum)[keyof typeof BsrRuleEntityLinkScalarFieldEnum]


export const BsrRuleSourceScalarFieldEnum = {
  id: 'id',
  sourceType: 'sourceType',
  sourceInfo: 'sourceInfo',
  recordedAt: 'recordedAt',
  ruleId: 'ruleId',
  tenantId: 'tenantId'
} as const

export type BsrRuleSourceScalarFieldEnum = (typeof BsrRuleSourceScalarFieldEnum)[keyof typeof BsrRuleSourceScalarFieldEnum]


export const AiSuggestionFeedbackScalarFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  feedbackType: 'feedbackType',
  entityType: 'entityType',
  entityId: 'entityId',
  metadata: 'metadata',
  createdAt: 'createdAt',
  userId: 'userId',
  tenantId: 'tenantId'
} as const

export type AiSuggestionFeedbackScalarFieldEnum = (typeof AiSuggestionFeedbackScalarFieldEnum)[keyof typeof AiSuggestionFeedbackScalarFieldEnum]


export const UiFilterViewScalarFieldEnum = {
  id: 'id',
  name: 'name',
  visibility: 'visibility',
  viewKey: 'viewKey',
  filters: 'filters',
  orderIndex: 'orderIndex',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tenantId: 'tenantId',
  createdById: 'createdById'
} as const

export type UiFilterViewScalarFieldEnum = (typeof UiFilterViewScalarFieldEnum)[keyof typeof UiFilterViewScalarFieldEnum]


export const DraftSalesOrderScalarFieldEnum = {
  draftOrderId: 'draftOrderId',
  salesOrderId: 'salesOrderId',
  type: 'type',
  state: 'state',
  notes: 'notes',
  release: 'release',
  external: 'external',
  totalAmount: 'totalAmount',
  totalGrossMargin: 'totalGrossMargin',
  billingAddress: 'billingAddress',
  shippingAddress: 'shippingAddress',
  contactPersonId: 'contactPersonId',
  contactPersonName: 'contactPersonName',
  dueDate: 'dueDate',
  deliveryDate: 'deliveryDate',
  shippingTypeId: 'shippingTypeId',
  storageId: 'storageId',
  clerkId: 'clerkId',
  lineItems: 'lineItems',
  businessCreatedAt: 'businessCreatedAt',
  submittedAt: 'submittedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  tenantId: 'tenantId',
  customerId: 'customerId',
  createdById: 'createdById'
} as const

export type DraftSalesOrderScalarFieldEnum = (typeof DraftSalesOrderScalarFieldEnum)[keyof typeof DraftSalesOrderScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

